import { ArrowDown } from 'lucide-react'

interface ScrollToBottomButtonProps {
  onClick: () => void
}

/**
 * Floating ↓ button — ChatGPT-style circular button.
 * Absolute-positioned at bottom-center of the chat area wrapper.
 * Always visible when shown (not inside the scroll container).
 */
export function ScrollToBottomButton({ onClick }: ScrollToBottomButtonProps) {
  return (
    <div className="absolute bottom-6 left-0 right-0 flex justify-center pointer-events-none z-20">
      <button
        onClick={onClick}
        className="pointer-events-auto w-10 h-10 rounded-full bg-foreground text-background shadow-[0_4px_16px_rgba(0,0,0,0.3)] hover:scale-110 transition-all duration-200 flex items-center justify-center border border-border/20 cursor-pointer"
        aria-label="Scroll to bottom"
      >
        <ArrowDown className="h-5 w-5" />
      </button>
    </div>
  )
}
